module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-horizontal-reverse.2d5e8f9135d5e82e.svg";